import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MuiToggleButton, { toggleButtonClasses } from '@mui/material/ToggleButton';
import MuiToggleButtonGroup, { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import * as React from 'react';
import { Typography } from '../typography';
const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)(({ theme }) => ({
    gap: '8px',
    [`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}`]: {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius
    },
    [`& .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.middleButton}`]: {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderLeft: `1px solid ${theme.palette.divider} !important`
    },
    [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]: {
        borderLeft: `1px solid ${theme.palette.action.disabledBackground}`
    }
}));
export const ToggleButtonGroup = (props) => {
    const { values, selected, onSelectedChange } = props;
    const handleSelected = (_event, newSelected) => {
        void onSelectedChange?.(newSelected);
    };
    return (_jsx(StyledToggleButtonGroup, { color: "primary", value: selected, onChange: handleSelected, children: values.map((val, i) => (_jsx(MuiToggleButton, { sx: { width: 53, height: 68 }, value: `${val.value}`, children: _jsx(Typography, { variant: "body2", color: "text.primary", children: val.label }) }, i))) }));
};
